import { Link } from "react-router-dom";

export default function Hero({partnerLogos, lang = "en"}) {
  // Add language labels
  const labels = {
    en: {
      title: "The Smartest AI Assistant, <br /> Ready to Chat!",
      description:"Simplify tasks, automate routines, and enjoy personalized interactions—all in one chat.",
      demo: "Demo",
      app: "App",
    },
    ar: {
      title: "واتسي مساعد ذكي، <br /> جاهز للدردشة!",
      description:"بسّط المهام، وحرّك الروتين، واستمتع بتجربة شخصية—كل ذلك في دردشة واحدة.",
      demo: "تجربة",
      app: "تطبيق",
    },
  };
  const currentLabels = labels[lang] || labels.en;
  return (
    <section
      className="relative bg-cover bg-center pt-20 h-[100dvh] border-b border-t  rounded-b-[25px]"
      id="hero"
      style={{ backgroundImage: "url('/landing/hero-bg.webp')" }}
    >
     
      <div className=" mx-auto p-10 text-center">
        <h1
          className="text-4xl md:text-6xl font-bold leading-tight mb-4 fade-down"
          dangerouslySetInnerHTML={{ __html: currentLabels.title }}
        />
        <p
          className="text-base sm:text-lg md:text-xl text-white/80 max-w-3xl mx-auto mb-6 sm:mb-8 fade-down"
          style={{ animationDelay: "0.2s" }}
        >
          {currentLabels.description}
        </p>
        <div className="relative mt-1 mx-auto ">
          <div className="hero-circles h-[180px] sm:h-[280px] md:h-[410px] overflow-hidden flex justify-center relative">
            <div className="relative flex justify-center items-end w-[95vw] max-w-[320px] sm:max-w-[500px] md:max-w-[800px] h-[180px] sm:h-[350px] md:h-[800px]">
              {/* Animated Circle Structure */}
              <div className="absolute inset-0 w-full h-full pointer-events-none">
                <div className="absolute inset-0 flex items-center justify-center z-0">
                  <img
                    src="/landing/outer-circle.svg"
                    alt="Outer Ring"
                    className="w-full h-full object-contain animate-spin-slow"
                    style={{ color: 'var(--color-primary)', maxWidth: "800px", maxHeight: "800px" }}
                  />
                </div>
                <div className="absolute inset-0 flex items-center justify-center z-10">
                  <img
                    src="/landing/icons.webp"
                    alt="Feature Icons"
                    className="absolute inset-0 w-full h-full p-2 sm:p-5 object-contain animate-spin-slow"
                    style={{ zIndex: 1 }}
                  />
                </div>
                <div className="absolute inset-0 flex items-center justify-center z-20">
                  <img
                    src="/landing/inner-circle.svg"
                    alt="Inner Ring"
                    className="w-full h-full object-contain animate-spin-slow"
                    style={{ maxWidth: "600px", maxHeight: "600px" }}
                  />
                </div>
              </div>
              <img
                src="/landing/bot-cropped.webp"
                alt="Chatbot"
                className="relative bottom-6 sm:bottom-12 md:bottom-20 z-30 h-[140px] sm:h-[250px] md:h-[900px]"
                style={{ objectFit: "contain" }}
              />
              {/* Buttons above the top of bot image */}
              <div
                className="absolute left-1/2 transform -translate-x-1/2 
             bg-[#041B29ED] rounded-[8px] sm:rounded-[10px]  p-3 
             sm:p-4 shadow-lg z-40 
             flex justify-center  pointer-events-auto 
             w-[90vw] max-w-[420px]  top-[calc(100%-80px)]
            sm:top-[calc(100%-450px)]"
              >
                <div
                  className="flex flex-row justify-center items-center space-x-2 sm:space-x-4 md:space-x-6 fade-down"
                  style={{ animationDelay: "0.4s" }}
                >
                  {/* Demo Button */}
                 <Link
                   to="/auth/login"
                    className="z-10 flex items-center  mx-1 justify-center w-full sm:w-[200px] h-10 px-4 sm:px-6 rounded-xl text-white font-semibold text-base shadow-none transition-colors"
                    style={{ backgroundColor: 'var(--color-primary)' }}
                  >
                    <span className="flex items-center justify-center space-x-2">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M10 8L16 12L10 16V8Z"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <span>{currentLabels.demo}</span>
                    </span>
                  </Link>

                  {/* Get App Button */}
                  <Link
                   to="/auth/login"
                    className="z-10 w-full sm:w-[200px] h-10  flex  items-center justify-center rounded-xl p-[3px]"
                    style={{ backgroundImage: 'linear-gradient(90deg,#D7FAFF, var(--color-primary))' }}
                  >
                    <div className="flex h-9 w-full items-center justify-center bg-[#041B29] rounded-[10px] sm:p-4 shadow-lg transition-colors">
                      <span className="flex items-center space-x-2 text-white font-semibold text-base">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M13 2L3 14H12L11 22L21 10H12L13 2Z"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span
                        
                          className="cursor-pointer"
                        >
                          {currentLabels.app}
                        </span>
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
  <div className="px-0 py-0 rounded-xl shadow-none transition-colors border-1 border-white/20 mt-4" style={{ backgroundImage: 'linear-gradient(90deg,#D7FAFF, var(--color-primary))' }}>
          <div className="border border-white/20 rounded-xl mx-auto py-3 sm:py-6 px-2 sm:px-8 bg-[#041B29]">
            <div className="flex   justify-around items-center gap-4 md:space-x-12 partner-logos overflow-auto">
              {partnerLogos.map((logo) => (
                <img
                  key={logo}
                  src={`/landing/${logo}`}
                  alt={logo}
                  className="h-8  "
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
